import { createContext } from 'react'

const AuthContext = createContext({});
const PathContext = createContext({});
const ProductsContext = createContext({});
const QuantityContext = createContext({});
const BadgeContext = createContext({});

export {
    AuthContext,
    PathContext,
    ProductsContext,
    QuantityContext,
    BadgeContext
}